import { render } from "./ShareDialog.vue?vue&type=template&id=9cb797c6&scoped=true"
import script from "./ShareDialog.vue?vue&type=script&lang=js"
export * from "./ShareDialog.vue?vue&type=script&lang=js"

import "./ShareDialog.vue?vue&type=style&index=0&id=9cb797c6&scoped=true&lang=scss"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cb797c6"]])

export default __exports__